module.exports = __webpack_public_path__ + "img/minexLogo.b1a6ee80.png";